import { OfReleaseFormsService, TaggableUser } from '@api'
import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast'
import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

export const useInvitationMutations = () => {
  const toast = useToast()
  const creatorId = useUnit($creatorId)!

  const createMutation = useMutation(
    (name: string) =>
      OfReleaseFormsService.createGuestUrl({
        creatorId,
        requestBody: {
          name,
        },
      }),
    {
      onError(error) {
        handleError(error, 'Something went wrong while inviting')
      },
    },
  )

  const editMutation = useMutation(
    ({ id, name }: Pick<TaggableUser, 'id' | 'name'>) =>
      OfReleaseFormsService.editGuestName({
        creatorId,
        guestId: id,
        requestBody: {
          name,
        },
      }),
    {
      onError(error) {
        handleError(error, 'Something went wrong while editing category')
      },
      onSuccess() {
        toast.success('Invite edited!')
      },
    },
  )

  return {
    onCreate: createMutation.mutateAsync,
    onEdit: editMutation.mutateAsync,
  }
}
